/**
 * Build-time configuration, read from Scala through the facade in io.intela.sites.intelaio.Env.
 *
 * Vite inlines import.meta.env.* at build time, which Scala.js output never sees, so the values pass
 * through this module. Only publishable values belong here: everything in it ships in the bundle.
 */
export const env = {
  siteUrl: (import.meta.env.VITE_SITE_URL ?? "http://localhost:5173").replace(/\/$/, ""),
  // True on every build but production's, so a staging copy is never indexed.
  noIndex: (import.meta.env.VITE_NO_INDEX ?? "true") === "true",
};
